<div class="title-container">
  <span class="title" [matTooltip]="message"
    >{{ route ? route + ': ' : '' }}{{ filename }}</span
  >
  <span *ngIf="!completed && !error && !rejected" class="state">{{
    started ? 'processing' : 'waiting'
  }}</span>
  <span class="icon-container">
    <mat-icon
      matTooltip="Clear"
      *ngIf="completed"
      class="item-icon complete"
      (click)="clickComplete()"
      >done</mat-icon
    >
    <mat-icon
      [matTooltip]="message"
      *ngIf="rejected"
      class="item-icon rejected"
      color="warn"
      >block</mat-icon
    >
    <mat-icon
      [matTooltip]="message"
      *ngIf="error"
      class="item-icon icon-error"
      color="warn"
      >error_outline</mat-icon
    >
    <mat-icon [matTooltip]="message" class="remove" (click)="clickComplete()"
      >remove</mat-icon
    >
  </span>
</div>
<mat-progress-bar
  *ngIf="!(error || rejected)"
  color="primary"
  [value]="completed ? 100 : error || rejected ? 0 : progress"
  [mode]="
    completed || error || rejected
      ? 'determinate'
      : started
        ? 'indeterminate'
        : 'query'
  "></mat-progress-bar>
